<template>
  <Transition name="banner">
    <div
      v-if="banner"
      class="billing-banner"
      :class="`billing-banner--${banner.type}`"
      role="alert"
    >
      <div class="billing-banner__content">
        <Icon :icon="bannerIcon" class="billing-banner__icon" />
        <span class="billing-banner__message">{{ banner.message }}</span>
      </div>
      <button
        v-if="banner.dismissible"
        class="billing-banner__dismiss"
        aria-label="Dismiss"
        @click="dismiss"
      >
        <Icon icon="mdi:close" />
      </button>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { Icon } from "@iconify/vue";
import { CLEAR_PERSISTENT_BANNER } from "@/store/mutation-types";

const store = useStore();

const banner = computed(() => store.getters.persistentBanner);

const bannerIcon = computed(() => {
  const t = banner.value?.type;
  if (t === "error") return "mdi:alert-circle-outline";
  if (t === "warning") return "mdi:alert-outline";
  return "mdi:information-outline";
});

const dismiss = () => {
  store.commit(CLEAR_PERSISTENT_BANNER);
};
</script>

<style scoped>
.billing-banner {
  width: 100%;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  z-index: 1000;
  color: #fff;
}

.billing-banner--error {
  background: #dc2626;
}

.billing-banner--warning {
  background: #d97706;
}

.billing-banner--info {
  background: #2563eb;
}

.billing-banner__content {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.billing-banner__icon {
  font-size: 18px;
  flex-shrink: 0;
}

.billing-banner__message {
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billing-banner__dismiss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  flex-shrink: 0;
}

.billing-banner__dismiss:hover {
  background: rgba(255, 255, 255, 0.25);
}

.billing-banner__dismiss .iconify {
  font-size: 14px;
}

.banner-enter-active,
.banner-leave-active {
  transition: all 0.3s ease;
}

.banner-enter-from,
.banner-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>
